import { CourseCompletedDetailsActions } from "./CourseCompletedDetails-slice";
import axios from 'axios'
// import '../utils/axios-interceptor'

export const fetchPageData = (url_data, token) => {
	// console.log("**************************************")
	// console.log(url_data)
	return async (dispatch) => {
		const fetchData = async () => {
			const response = await axios.get(url_data, {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response.data;

			return data;
		};

		try {
			const pageData = await fetchData();
			dispatch(CourseCompletedDetailsActions.updatePageData(pageData));
		} catch (error) {
			console.log(error);
		}
	};
};

export const submitRating = (url_data, formData, token) => {
	// console.log("**************************************")
	// console.log(url_data)
	return async (dispatch) => {
		const fetchData = async () => {
			const response = await axios.post(url_data, JSON.stringify(formData), {token: token});

			if (response.status !== 200) {
				throw new Error("Fetching data failed.");
			}

			const data = await response.data;

			return data;
		};

		try {
			const pageData = await fetchData();
			// dispatch(CourseCompletedDetailsActions.updatePageData(pageData));
		} catch (error) {
			console.log(error);
		}
	};
};

